module.exports = __webpack_public_path__ + "media/images/parallax/illustration-be-background-19bb43084124c5953c204c1791a82280.png";